import axios from "axios";

/**
 * @description Get user parents class from API /api/classroom/homeschool/get-parent-class
 * and make ajax request to save user_platform_id in database
 * 
 * @param {Function} callbackFunction 
 * @returns {void}
 */
function APIGetParentClass( callbackFunction ) {
    let hostname = window.location.hostname;
    let protocol = window.location.protocol;
    let api_url = protocol + "//api." + hostname + "/api/classroom/homeschool/get-parent-class";

    // Check if User Logged In
    if(  window.UserProfile.is_logged_in == undefined || window.UserProfile.is_logged_in == false ) {
        return;
    };


    // Check User Has Access to the Class 
    var has_subscription = window.UserProfile.has_subscription;
    
    if( has_subscription == undefined || has_subscription == false ) {
        return
    }; 

    axios.post(
        api_url,
        null,
        {
            withCredentials: true
        }
    )
    .then( response => {

        // Save API Data to cookies
        var data = response.data.data;
        
        if( data.name ) {
            window.UserProfile.class_name = data.name;
        }

        if( data.available_seats !== undefined ) {
            window.UserProfile.available_seats = data.available_seats;
        }
        
        if( data.id ) {
            window.UserProfile.class_id = data.id;
        }

        if ( data.orderId ) {
            window.UserProfile.orderId = +data.orderId;

            let orderId = +data.orderId,
                userPlatformId = window.UserProfile.user_id;

        	const formData = new FormData();

        	formData.append( "action", "gocoderz_save_user_platform_id" );
        	formData.append( "nonce", gocoderzAjax.nonce );
        	formData.append( "order_id", orderId );
        	formData.append( "user_platform_id", userPlatformId );

        	fetch( gocoderzAjax.url, {
        		method: "POST",
        		credentials: "same-origin",
        		body: formData
        	} )
        		.then( ( response ) => response.json() )
        		.then( ( data ) => {
        			if ( data.status == false ) {
        				throw new Error( "wrong order id provided" );
        			}
        		} )
        }

        if( data.students_count !== undefined ) {
            window.UserProfile.students_count = data.students_count;
        }
        

        // Run Callback Function
        if ( 'function' == typeof callbackFunction ) {
            callbackFunction();
        }
    } )
    .catch( ( error ) => {
        console.log( error )
    } );
}

export { APIGetParentClass };
